/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 02.08.2016.
 */

import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import ClassNames from 'classnames';
import _get from 'lodash/get';

import {deepPick} from '../../../utils';

import DivLoader from '../../../components/DivLoader';
import Translate from '../../../components/Translate';
import {InitApplication} from '../../../actions/common/actions-common';

class PinMessage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pin: '',
      isShown: false
    };
  }

  componentDidMount() {

    document.getElementById('pinCode') && document.getElementById('pinCode').focus();

    document.getElementById('dummy_submit') && document.getElementById('dummy_submit').addEventListener('focus', ()=> {
      document.getElementById('pinCode') && document.getElementById('pinCode').focus();

    });

    this.setState({
      isShown: this.props.isShown
    });
  }

  componentWillReceiveProps(newProps) {
    let state = {};

    state.isShown = newProps.isShown;

    this.setState(state);

    if (!newProps.actionState.inProgress && newProps.actionState.isSuccess) {
      this.props.onClose();

      if (newProps.actionState.isReloadNeeded) {
        this.props.InitApplication(newProps.user);
      }
    }
  }

  _onPinChange(event) {

    this.setState({
      pin: event.target.value
    });
  }

  _onSubmit(event) {
    event.preventDefault && event.preventDefault();

    this.props.message.actionOnSubmit(this.state.pin);
  }

  render() {

    const InputClasses = ClassNames({
      'pin-input': true,
      'animate-shake': this.props.actionState.isError
    });

    return (<div className="confirm-payment-popup">
      <DivLoader loading={this.props.actionState.inProgress} />
      <a className="mw-close ico ico-close pointer slider-resume" onClick={this.props.onClose.bind(this)}></a>
      <form onSubmit={this._onSubmit.bind(this)}>
        <p style={{margin: '0 auto'}}>
          <strong> <Translate content="messages.pin.title" /> </strong>
          <input id="pinCode" type="password" maxLength="4" name="pinCode" className={InputClasses} tabIndex="1"
                 onChange={this._onPinChange.bind(this)}
                 value={this.state.pin} />
          <input id="dummy_submit" type="text" style={{height: 0, width: 0, opacity: 0, display: 'block', float: 'left'}} tabIndex="2" />
          <button type="submit" style={{height: 0, opacity: 0, visibility: 'hidden'}} tabIndex="3">Submit</button>
        </p>
      </form>
      {this.props.actionState.isError && <div className="reg-error-message">
        <em> <Translate content={`error.${this.props.actionState.errorMsg}`} /> </em>
      </div>}
      <div className="mt+ message-actions">
        <a className="btn-dark-popup ok" href="javascript:void(0)" onClick={this._onSubmit.bind(this)}> <Translate content="messages.pin.ok" /> </a>
        <a className="btn-dark-popup cancel" href="javascript:void(0)" onClick={this.props.onClose.bind(this)}> <Translate content="messages.pin.cancel" /> </a>
      </div>
    </div>);
  }
}


PinMessage.propTypes = {
  message: PropTypes.shape({
    type: PropTypes.string.isRequired,
    actionOnSubmit: PropTypes.func.isRequired,
    actionState: PropTypes.object
  }),
  actionState: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  isShown: PropTypes.bool.isRequired
};

const mapStateToProps = (state, ownProps) => {
  return {
    actionState: deepPick(state, ownProps.message.actionState).parental,
    user: _get(state, 'auth.user'),
  };
};

const mapDispatchToProps = (dispatch) => {

  return bindActionCreators({InitApplication}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(PinMessage);



// WEBPACK FOOTER //
// ./src/components/ModalWindow/Pin/pin-message.js